import React from "react";
import AppBar from '../../../components/app_bar.js'
import BottomNavBar from "../../../components/bottom_nav_bar.js";
import Background from "../../../components/background.js";
import WheelOfFortune from '../../../components/spin.js'
import '../style/spin.css'

function SpinPage() {
  return <>
    <AppBar />
    <BottomNavBar />
    <Background />
    <div className="spinner-wrapper">
      <WheelOfFortune />
    </div>
  </>;
}

export default SpinPage;